import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-content-skeleton',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './content-skeleton.component.html',
  styleUrls: ['./content-skeleton.component.css']
})
export class ContentSkeletonComponent {
  @Input() variant: 'entity-list' | 'stats' | 'table' | 'pills' | 'chart' = 'entity-list';
  @Input() count = 6;
  @Input() columns = 4;
  @Input() rows = 5;
  @Input() showHeader = true;

  get itemArray(): number[] {
    return Array.from({ length: Math.max(1, Number(this.count) || 1) }, (_, index) => index);
  }

  get rowArray(): number[] {
    return Array.from({ length: Math.max(1, Number(this.rows) || 1) }, (_, index) => index);
  }

  get columnArray(): number[] {
    return Array.from({ length: Math.max(1, Number(this.columns) || 1) }, (_, index) => index);
  }

  get gridTemplateColumns(): string {
    return `repeat(${Math.max(1, this.columns)}, minmax(0, 1fr))`;
  }

  showSecondaryLine(columnIndex: number): boolean {
    return columnIndex === 0 || columnIndex % 2 === 0;
  }
}
